const handleChangeAddress = (setAddress,fieldName,value) =>{
  setAddress(prevState => ({
    ...prevState,
    [fieldName]:value
  }));
}; 

export {handleChangeAddress};